import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import DescriptionDetails from "components/DescriptionDetails";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import { Repo } from "types/generated";

type RepoDetailsDrawerProps = {
  repo: Repo;
};

const RepoDetailsDrawer = createDrawer(({ repo }: RepoDetailsDrawerProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(repo.description);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Repository details" />
        <DrawerCloseIcon />
      </DrawerHeader>

      <DrawerBody>
        <FormFieldViewText label="ID" value={repo.id} withCopy />
        <FormFieldViewText label="Name" value={repo.name} />

        {repo.space && (
          <FormField label="Space">
            <SpacePath
              variant="expandable"
              spaceId={repo.space.id}
              fallbackName={repo.space.name}
            />
          </FormField>
        )}

        <DescriptionDetails
          description={repo.description}
          onOpenFullDescription={onOpenFullDescription}
        />

        <FormFieldTimestamp label="Created at" timestamp={repo.createdAt} />
        <FormFieldTimestamp label="Last updated" timestamp={repo.updatedAt} />

        {repo.labels.length > 0 && (
          <FormField label="Labels">
            <TagsList tags={repo.labels} alwaysExpanded />
          </FormField>
        )}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showRepoDetailsDrawer = createDrawerTrigger(RepoDetailsDrawer);
